import React, { useCallback, useEffect, useState } from "react";
import { Button } from "@mui/material";
import {
    PublicClientApplication,
    EventType,
} from "@azure/msal-browser";
import { msalConfig } from "../../configs/azureAuthConfig";

function AppleIdButton({ onSuccess, onError, msClient }) {
    const [loading, setLoading] = useState(false);

    const handleLogin = useCallback(() => {
        setLoading(true);
        window.location.assign(`${process.env.REACT_APP_API_SAML_URL}`);
    }, []);

    return (
        <Button className="btn-login-confirm-black btn-principal" onClick={handleLogin} >
            Iniciar sesión con Apple IDMS
        </Button>
    );
}

export function AppleSamlSessionProbe({ onAuthenticated, onUnauthenticated }) {
    const [status, setStatus] = useState("loading");

    useEffect(() => {
        const checkSession = async () => {
            try {
                const response = await fetch(`${process.env.REACT_APP_API_SAML_URL}/auth/saml/me`, {
                    method: "GET",
                    credentials: "include",
                });

                if (!response.ok) {
                    setStatus("unauthenticated");
                    onUnauthenticated?.();
                    return;
                }

                const data = await response.json();
                setStatus("authenticated");
                onAuthenticated?.(data.user);
            } catch (error) {
                setStatus("error");
                onUnauthenticated?.();
            }
        };

        checkSession();
    }, [onAuthenticated, onUnauthenticated]);

    if (status === "loading") return <p>Validando sesión...</p>;
    if (status === "authenticated") return <p>Sesión activa.</p>;
    if (status === "unauthenticated") return <p>No autenticado.</p>;
    return <p>Error validando sesión.</p>;
}

export default AppleIdButton